/* eslint-disable */
import React, {useState} from 'react';
import 'contents/assets/scss/page/student.scss';
import Tab from '../../component/Inc/Tab';
import Paging from '../../component/Inc/Paging';
import Modal from '../../component/Inc/Modal';
import PopTimeChangeReport from './_PopTimeChangeReport';
function TimeChange() {
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    {title: '전체', value: 0},
    {title: '타임추가', value: 1},
    {title: '타임축소', value: 2},
    {title: '보류', value: 3},
    {title: '재개', value: 4},
    {title: '재개 예상 지난 보고서', value: 5}
  ];
  const [modalReport, setModalReport] = useState(false);
  const [modalRestart, setModalRestart] = useState(false);
  return (
    <main className="com_container p_time_change com_input">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu1_10">타임변경/보류/재개</h2>
          <div className="com_btn_wrap">
            <button onClick={() => setModalReport(true)} className="com_btn orange s btn_plus">
              타임변경/보류 보고서 등록
            </button>
          </div>
        </section>
        <section className="com_pg_container">
          <section className="box">
            <div className="com_board_list__top">
              <Tab data={tab} tab={tabIdx} setTab={setTabIdx} />
              <section className="com_board_search end">
                <article className="search">
                  <input type="search" placeholder="검색할 내용을 입력" className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>
            <table className="com_board_list">
              <colgroup>
                <col width="8%" />
                <col width="13%" />
                <col width="13%" />
                <col width="13%" />
                <col width="13%" />
                <col width="13%" />
                <col width="13%" />
                <col width="13%" />
              </colgroup>
              <thead>
                <tr>
                  <th>No.</th>
                  <th>등록일</th>
                  <th>등록자</th>
                  <th>교사</th>
                  <th>과목</th>
                  <th>구분</th>
                  <th>변경내용</th>
                  <th>진행 회차</th>
                </tr>
              </thead>
              <tbody>
                <tr className="selected">
                  <td>1</td>
                  <td className="td_date">2022, 08, 20</td>
                  <td>
                    <button className="btn_link">김등록103</button>
                  </td>
                  <td>
                    <button className="btn_link">김교사103</button>
                  </td>
                  <td>국어</td>
                  <td>타임추가</td>
                  <td>+ 2</td>
                  <td>78</td>
                </tr>
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i, idx) => {
                  return (
                    <tr key={idx}>
                      <td>{idx + 1}</td>
                      <td className="td_date">2022, 08, 20</td>
                      <td>
                        <button className="btn_link">김등록103</button>
                      </td>
                      <td>
                        <button className="btn_link">김교사103</button>
                      </td>
                      <td>국어</td>
                      <td>타임추가</td>
                      <td>+ 2</td>
                      <td>78</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <Paging />
          </section>
          {/* 상세보기 */}
          <section className="box">
            <div className="detail_tit dot">보고서 상세</div>
            <div className="com_info">
              <p className="name">홍길동103</p>
              <span className="dot" />
              <p className="date">2023.05.20 11:30</p>
              <div className="count">
                <button className="btn_edit" />
                <button className="btn_delete" />
              </div>
            </div>
            <div className="com_btn_wrap">
              <span className="com_btn lightRed s bold">타임추가 +2</span>
            </div>
            <div className="com_board_box">
              <div className="board_item">
                <div className="info">
                  <span className="tit">학생명</span>
                  <span className="cont">홍학생103(고3ㆍ본사) </span>
                </div>
                <div className="info">
                  <span className="tit">전화번호</span>
                  <span className="cont">010-1234-134</span>
                </div>
                <div className="info">
                  <span className="tit">부모폰</span>
                  <span className="cont">부) 010-1234-0134 | 모) 010-1345-3214</span>
                </div>
                <div className="info">
                  <span className="tit">홍보</span>
                  <span className="cont">김홍보320</span>
                </div>
                <div className="info">
                  <span className="tit">담임</span>
                  <span className="cont">김담임445</span>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <span className="tit">수업 방법</span>
                  <span className="cont">대면</span>
                </div>
                <div className="info">
                  <span className="tit">수업 과목</span>
                  <span className="cont">과탐</span>
                </div>
                <div className="info">
                  <span className="tit">수업 상세</span>
                  <span className="cont">사회문화, 경제, 밥과정서</span>
                </div>
                <div className="info">
                  <span className="tit">기수 / 타임</span>
                  <span className="cont">2기 / 2T</span>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <span className="tit">수업료</span>
                  <span className="cont">2,500,000</span>
                </div>
                <div className="info">
                  <span className="tit">시수</span>
                  <span className="cont">45,000</span>
                </div>
                <div className="info">
                  <span className="tit">DC 금액 / 사유</span>
                  <span className="cont">-50,000 / 2기 수업으로</span>
                </div>
                <div className="info">
                  <span className="tit">실 수업료</span>
                  <span className="cont">2,495,000</span>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <span className="tit">완성 여부</span>
                  <span className="cont">Y</span>
                </div>
                <div className="info">
                  <span className="tit">비교 수업</span>
                  <span className="cont">N</span>
                </div>
                <div className="info">
                  <span className="tit">첫 수업일</span>
                  <span className="cont">2022, 08, 25 | 19:30</span>
                </div>
                <div className="info">
                  <span className="tit">마지막 수업일</span>
                  <span className="cont">2023, 05, 30 | 20:30</span>
                </div>
                <div className="info">
                  <span className="tit">수업 장소</span>
                  <span className="cont">경기도 수원시 팔달구 팔달로1465 모여라 빌딩 203호</span>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <span className="tit">
                    진행 수업 수 /<br />총 수업 수
                  </span>
                  <span className="cont com_blue_txt">45 / 65</span>
                </div>
                <div className="info">
                  <span className="tit">최근 수업일</span>
                  <span className="cont com_blue_txt">2023, 05, 08 | 12:30</span>
                </div>
                <div className="info">
                  <span className="tit">진행률</span>
                  <span className="cont">65%</span>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <span className="tit">보류 시작일</span>
                  <span className="cont com_blue_txt">2023, 04, 08</span>
                </div>
                <div className="info">
                  <span className="tit">재개 예상일</span>
                  <span className="cont com_blue_txt">2023, 05, 12</span>
                </div>
              </div>
            </div>
            <div className="com_btn_wrap center bottom">
              <button onClick={() => setModalRestart(true)} className="com_btn gray s">
                수업재개
              </button>
            </div>
            <div className="com_board_box">
              <div className="board_item">
                <div className="info">
                  <span className="cont">
                    <button className="name">김담임102 </button>
                    <span className="desc dot">2025, 05, 20 11 : 30</span>
                  </span>
                </div>
                <hr className="com_divider" />
                <div className="info">확인 완료.</div>
              </div>
            </div>
            <div className="com_board_box">
              <textarea className="textarea" name="" id="" placeholder="내용 입력"></textarea>
            </div>
            <div className="com_btn_wrap center bottom">
              <button className="com_btn orange s">등록</button>
            </div>
          </section>
        </section>
      </div>
      <PopTimeChangeReport open={modalReport} close={() => setModalReport(false)} />
      <Modal open={modalRestart} close={() => setModalRestart(false)} type="type_alert">
        <div className="content_container com_input_sec">
          <h2 className="pop_tit">수업을 다시 재개 하시겠습니까?</h2>
          <h2 className="pop_board_tit">재개일</h2>
          <div className="date_wrap">
            <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
          </div>
        </div>
        <div className="btn_container">
          <button className="com_btn lightGray xs">취소</button>
          <button className="com_btn orange xs">확인</button>
        </div>
      </Modal>
    </main>
  );
}

export default TimeChange;
